document.addEventListener('DOMContentLoaded', () => {
  const tabLinks = document.querySelectorAll('.tab-link');
  const tabContents = document.querySelectorAll('.tab-content');
  const accordionLabels = document.querySelectorAll('.collapse-label');
  let currentOpenAccordion = null;
    const headerHeight = document.querySelector(".header")?.offsetHeight || 0;

  const getIsMobile = () => window.innerWidth <= 767;
  let isMobile = getIsMobile();

  const activateTab = (id) => {
    tabContents.forEach(content => {
      content.style.display = content.id === id ? 'block' : 'none';
    });
    tabLinks.forEach(link => {
      link.classList.toggle('active', link.getAttribute('for') === id);
    });

      if (currentOpenAccordion && isMobile) {
           const currentWrapper = document.querySelector(`.tab-wrapper > label[for="${id}"]`);
             if (currentWrapper) {
                const scrollY = currentWrapper.getBoundingClientRect().top + window.scrollY - headerHeight;
                window.scrollTo({
                  top: scrollY,
                   behavior: 'smooth'
              });
             }
        }
  };

  const handleAccordionClick = (label) => {
      const id = label.getAttribute('for');
    if (currentOpenAccordion && currentOpenAccordion !== id) {
           const current = document.querySelector(`.tab-wrapper > label[for="${currentOpenAccordion}"]`);
           if(current){
              const inputElement = document.getElementById(currentOpenAccordion);
               inputElement.checked = false;
          }
     }
     const inputElement = document.getElementById(id);
     inputElement.checked = true;
      activateTab(id);
    currentOpenAccordion = id;

  }

  tabLinks.forEach(link => {
    link.addEventListener('click', () => {
      if (getIsMobile()) return;
      activateTab(link.getAttribute('for'));
    });
  });

  accordionLabels.forEach(label => {
    label.addEventListener('click', () => {
      handleAccordionClick(label)
    });
  });

  // Initial aktivieren
  if (tabLinks.length > 0 && !getIsMobile()) {
    activateTab(tabLinks[0].getAttribute('for'));
  }
  else if(accordionLabels.length > 0){
      handleAccordionClick(accordionLabels[0])
  }

  // Event-Listener für Fenstergrößenänderung
  window.addEventListener('resize', () => {
     isMobile = getIsMobile();
  });
});